export default "__VITE_ASSET__IB40ZjpY__"